import React from "react";
import "../styles/BusinessOverview.css";
import PlusIcon from "../icons/BusinessHub/PlusIcon";
import CompIcon from "../icons/BusinessHub/CompIcon";
import { useState, useEffect, useRef } from "react";
import BranchLogo from "../icons/BusinessHub/BranchLogo";
import ArrowFront from "../icons/BusinessHub/ArrowFront";
import WarehousesIcon from "../icons/BusinessHub/WarehousesIcon";
import { useNavigate } from "react-router-dom";
import companyController from "../controllers/companyController";
import { userService } from "../services/userService";
import Utils from "../utils/Utils.js";
import NoRelatedCom from "../icons/BusinessHub/NoRelatedCom.js";
import ReactCountryFlag from "react-country-flag";
import CountriesController from "../controllers/CountriesController.js";
import DescriptionIcon from "../icons/BusinessHub/DescriptionIcon.js";
import { toast } from "react-toastify";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton.js";
import EditDetails from "../icons/BusinessHub/EditDetails.js";
import TrashIcon from "../icons/BusinessHub/TrashIcon.js";

function BussinessOverview() {
  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState("");

  const companyID = userService.getCompID();
  const Authorization = userService.getUser();
  const [countries, setCountries] = useState([]);
  const [disc, setdisc] = useState(null);
  const [edit, setedit] = useState(true);
  const navigate = useNavigate();
  const [companies, setcompanies] = useState([]);
  const [ownername, setownername] = useState("");
  const [active, setActive] = useState("Manufacturers");
  const rowClass = (key) =>
    active === key
      ? "business-overview-branch-business-selected"
      : "business-overview-branch-business";

  useEffect(() => {
    const parsed = Utils.parseJwt(Authorization);

    const businessProfileID = userService.getBPID();
    const getCompaniesData = async () => {
      const getCompanies = await companyController.getBusinesProfileCompanies({
        Authorization: Authorization,
        businessProfileID: businessProfileID,
      });
      // setcompanies(getCompanies.data);
      const companiesArray = Array.isArray(getCompanies.data)
        ? getCompanies.data
        : [getCompanies.data];
      setownername(getCompanies?.data?.ownerName);
      setcompanies(companiesArray);
      setSelectedCompanyLogo(companiesArray?.companyLogo);
    };
    getCompaniesData();
  }, []);
  /************************************************************* */

  const [logo, setlogo] = useState({ name: "" });
  const logoRef = useRef(null);
  const modalLogoInputRef = useRef(null);
  const modalPreviewImageRef = useRef(null);
  const editPreviewImageRef = useRef(null);
  const editPreviewLoaderRef = useRef(null);
  const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);
  // const [selectedCompanyLogo, setSelectedCompanyLogo] = useState("");
  const [isEditLogoModalOpen, setIsEditLogoModalOpen] = useState(false);
  const [editPreviewSrc, setEditPreviewSrc] = useState("");
  const [isEditPreviewLoading, setIsEditPreviewLoading] = useState(false);
  const [editZoom, setEditZoom] = useState(1);
  const [editRotate, setEditRotate] = useState(0);
  const [isSavingEditedLogo, setIsSavingEditedLogo] = useState(false);
  const minEditZoom = 1;
  const maxEditZoom = 3;
  const editZoomStep = 0.1;

  const openLogoModal = (logoUrl) => {
    if (!logoUrl) return;
    setSelectedCompanyLogo(logoUrl);
    setIsLogoModalOpen(true);
  };

  const closeLogoModal = () => {
    setIsLogoModalOpen(false);
    // setSelectedCompanyLogo("");
  };

  const openEditLogoModal = () => {
    if (!selectedCompanyLogo) return;

    setIsEditPreviewLoading(true);
    setEditZoom(1);
    setEditRotate(0);

    const modalImage = modalPreviewImageRef.current;

    if (modalImage?.currentSrc) {
      fetch(modalImage.currentSrc)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to load image for editing.");
          }
          return response.blob();
        })
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);
          setEditPreviewSrc((prev) => {
            if (prev && prev.startsWith("blob:")) {
              URL.revokeObjectURL(prev);
            }
            return objectUrl;
          });
          setIsEditPreviewLoading(false);
          setIsLogoModalOpen(false);
          setIsEditLogoModalOpen(true);
        })
        .catch(() => {
          const preloadImage = new Image();
          editPreviewLoaderRef.current = preloadImage;

          preloadImage.onload = () => {
            if (editPreviewLoaderRef.current !== preloadImage) return;
            setEditPreviewSrc(selectedCompanyLogo);
            setIsEditPreviewLoading(false);
            setIsLogoModalOpen(false);
            setIsEditLogoModalOpen(true);
          };

          preloadImage.onerror = () => {
            if (editPreviewLoaderRef.current !== preloadImage) return;
            setIsEditPreviewLoading(false);
            toast.error("Failed to load image for editing.");
          };

          preloadImage.src = selectedCompanyLogo;
        });
      return;
    }

    const preloadImage = new Image();
    editPreviewLoaderRef.current = preloadImage;

    preloadImage.onload = () => {
      if (editPreviewLoaderRef.current !== preloadImage) return;
      setEditPreviewSrc(selectedCompanyLogo);
      setIsEditPreviewLoading(false);
      setIsLogoModalOpen(false);
      setIsEditLogoModalOpen(true);
    };

    preloadImage.onerror = () => {
      if (editPreviewLoaderRef.current !== preloadImage) return;
      setIsEditPreviewLoading(false);
      toast.error("Failed to load image for editing.");
    };

    preloadImage.src = selectedCompanyLogo;
  };

  const closeEditLogoModal = () => {
    setIsEditLogoModalOpen(false);
    setIsLogoModalOpen(true);
  };

  const saveEditLogoModal = async () => {
    if (!selectedCompanyLogo || isSavingEditedLogo) return;

    try {
      setIsSavingEditedLogo(true);

      const imageElement = editPreviewImageRef.current;
      if (!imageElement?.naturalWidth || !imageElement?.naturalHeight) {
        throw new Error("Image is not ready yet.");
      }

      const canvas = document.createElement("canvas");
      const canvasSize = 300;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        throw new Error("Could not prepare edited image.");
      }

      canvas.width = canvasSize;
      canvas.height = canvasSize;

      const imageWidth = imageElement.naturalWidth;
      const imageHeight = imageElement.naturalHeight;
      const baseScale = Math.max(
        canvasSize / imageWidth,
        canvasSize / imageHeight,
      );
      const finalScale = baseScale * editZoom;

      ctx.clearRect(0, 0, canvasSize, canvasSize);
      ctx.save();
      ctx.translate(canvasSize / 2, canvasSize / 2);
      ctx.rotate((editRotate * Math.PI) / 180);
      ctx.scale(finalScale, finalScale);
      ctx.drawImage(imageElement, -imageWidth / 2, -imageHeight / 2);
      ctx.restore();

      const editedBlob = await new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
              return;
            }
            reject(new Error("Failed to generate edited image."));
          },
          "image/jpeg",
          0.95,
        );
      });

      const editedFileName =
        logo?.name ||
        `company-logo-edited-${userService.getCompID() || Date.now()}.jpg`;
      const editedFile = new File([editedBlob], editedFileName, {
        type: "image/jpeg",
      });

      const fileData = await Utils.processImageFile(editedFile);
      setlogo(fileData);
      const uploadResult = await handleFileChange(fileData);

      if (Utils.isSuccessResponse(uploadResult)) {
        toast.success("Company logo updated.");
        setIsEditLogoModalOpen(false);
        closeLogoModal();
        window.location.reload();
      } else {
        toast.error(
          uploadResult?.response?.data?.message ||
            "Company logo could not be updated.",
        );
      }
    } catch (err) {
      toast.error(err.message || "Failed to save edited photo.");
    } finally {
      setIsSavingEditedLogo(false);
    }
  };

  const onLogoInputChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const fileData = await Utils.processImageFile(file);
      setlogo(fileData);
      const uploadResult = await handleFileChange(fileData);
      if (Utils.isSuccessResponse(uploadResult)) {
        toast.success("Company logo updated.");
        closeLogoModal();
        window.location.reload();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  const handleFileChange = async (logoDataArg) => {
    const copmayRequest = {
      businessProfileID: userService.getBPID(),
      companyId: userService.getCompID(),
    };

    const compDetails = await companyController.getCompanyDetails({
      copmayRequest: copmayRequest,
      Authorization: userService.getUser(),
    });

    const logoData = logoDataArg ?? logo;

    if (!logoData?.base64 || !logoData?.name) {
      alert("Select a logo first.");
      return;
    }

    const parsed = Utils.parseJwt(Authorization);
    const addAttachments = {
      companyID: companyID,
      // attachmentType: "COMPANY_LOGO",
      customObject: [
        {
          attachmentStatus: "DEFAULT",
          attachmentType: "COMPANY_LOGO",
          countryName: compDetails?.data?.countryName || "LEBANON",
          customPath: "string",
          data: logoData.base64,
          extension: (logoData.name || "").split(".").pop(),
          objectName: logoData.name,
          userName: parsed.username,
        },
      ],
    };

    return companyController.updateAddCompanyAttachments({
      addAttachments,
      Authorization,
    });
    // if()
  };
  /**************************************************************** */
  const handleEditClick = () => {
    navigate("/register-company");
  };

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const response = await CountriesController.getCountries();
        const backendData = response?.data;
        if (Array.isArray(backendData)) {
          setCountries(
            backendData.map((c) => ({
              code: c.countryCode,
              label: c.countryName,
              dialCode: c.suffix,
            })),
          );
        } else setCountries([]);
      } catch {
        setCountries([]);
      }
    };
    loadCountries();
  }, []);
  const handleEditDisc = async () => {
    try {
      const companyDescription = {
        companyDescription: disc,
        companyID: userService.getCompID(),
      };
      const upDisc = await companyController.updateCompanyDescription({
        companyDescription: companyDescription,
        Authorization: Authorization,
      });
      if (Utils.isSuccessResponse(upDisc) && upDisc.data === true) {
        setedit(true);
        toast.success("Description updated");
      } else {
        toast.error("err");
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (isLogoModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isLogoModalOpen]);

  useEffect(() => {
    return () => {
      editPreviewLoaderRef.current = null;
      if (editPreviewSrc && editPreviewSrc.startsWith("blob:")) {
        URL.revokeObjectURL(editPreviewSrc);
      }
    };
  }, [editPreviewSrc]);
  return (
    <div className="business-overview-main-container">
      <div className="business-overview-header">
        <div className="overview-header-text">
          <div className="overview-header-title">
            Welcome back, {ownername ? ownername : null}
          </div>
          <div className="overview-header-text-note">
            Here's an overview of your business profile
          </div>
        </div>
        <div className="overview-header-actionButton-cont">
          <div
            className="overview-header-actionButton"
            onClick={() => {
              handleEditClick();
            }}
          >
            <div className="overview-header-plus-icon">
              <PlusIcon fill="currentColor" />
            </div>
            <div className="overview-header-actionButton-text">New Company</div>
          </div>
        </div>
      </div>
      <div className="business-overview-comp-details">
        {Array.isArray(companies) &&
          companies?.map((item, index) => (
            <div className="business-overview-body" key={index}>
              <div className="overview-body-comp-details">
                <div className="overview-comp-intro-header">
                  <div className="overview-comp-intro-header-title">
                    <div className="overview-comp-intro-header-icon">
                      <CompIcon />
                    </div>
                    <div className="overview-comp-intro-header-title-text">
                      Current Company Information
                    </div>
                  </div>
                  <div className="overview-comp-intro-header-title-disc">
                    Active Company Details {item?.companyName}
                  </div>
                </div>
                <div className="overview-comp-details-content">
                  <div className="overview-comp-details-comp-logo">
                    {item?.companyLogo ? (
                      <div
                        className="company-logo-wrapper"
                        onClick={() => {
                          openLogoModal(item?.companyLogo);
                        }}
                      >
                        <img
                          className="company-logo-display"
                          src={item?.companyLogo}
                          alt="Company logo"
                        />

                        <div className="company-logo-overlay">
                          <span>Edit</span>
                        </div>
                      </div>
                    ) : (
                      <label
                        className="upload-button"
                        style={{ fontWeight: "600" }}
                      >
                        + Add Your Company Logo
                        <input
                          type="file"
                          ref={logoRef}
                          style={{ display: "none" }}
                          onChange={onLogoInputChange}
                        />
                      </label>
                    )}
                  </div>
                  <div className="overview-comp-owner-details">
                    <div className="overview-comp-owner-details-containers">
                      <div className="overview-comp-owner-details-content">
                        <div className="overview-comp-owner-details-content-details">
                          Company Name
                        </div>
                        <div className="overview-comp-owner-details-content-detail">
                          {item?.companyName}
                        </div>
                      </div>

                      <div className="overview-comp-owner-details-content">
                        <div className="overview-comp-owner-details-content-details">
                          Email
                        </div>
                        <div className="overview-comp-owner-details-content-detail">
                          {item?.ownerEmail}
                        </div>
                      </div>
                    </div>

                    <div className="overview-comp-owner-details-containers">
                      <div className="overview-comp-owner-details-content">
                        <div className="overview-comp-owner-details-content-details">
                          Owner Name
                        </div>
                        <div className="overview-comp-owner-details-content-detail">
                          {item?.ownerName}
                        </div>
                      </div>

                      <div className="overview-comp-owner-details-content">
                        <div className="overview-comp-owner-details-content-details">
                          Phone Number
                        </div>
                        <div className="overview-comp-owner-details-content-detail">
                          <div className="comp-details-data-phone">
                            {(() => {
                              const country = countries.find(
                                (c) =>
                                  String(c.dialCode) ===
                                  String(item?.ownerPhoneNumberSuffix),
                              );
                              const countryCode = country?.code;
                              return (
                                <>
                                  {countryCode && (
                                    <ReactCountryFlag
                                      countryCode={countryCode}
                                      svg
                                      style={{
                                        width: "1.6em",
                                        height: "1.6em",
                                        marginRight: "0.5em",
                                      }}
                                    />
                                  )}
                                  {"+" + item?.ownerPhoneNumberSuffix}{" "}
                                  {item?.ownerPhoneNumber}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="overview-comp-owner-details-containers-state">
                      <div className="overview-comp-owner-details-content">
                        <div className="overview-comp-owner-details-content-details">
                          Status
                        </div>
                        {item?.isActive === null ? null : item?.isActive ? (
                          <div className="overview-comp-owner-details-content-detail-state">
                            Active
                          </div>
                        ) : (
                          <div className="overview-comp-owner-details-content-detail-state-inactive">
                            Inactive
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="related-business-reg-info-data-input-email-dis">
                    <div className="related-business-reg-info-data-input-cont-discription">
                      <div className="related-business-reg-icon">
                        <DescriptionIcon />
                      </div>
                      Description
                    </div>
                    <div className="related-business-reg-info-input-data-disc-add">
                      <textarea
                        disabled={edit ? true : false}
                        placeholder={item?.companyDescriptions}
                        className="related-business-reg-info-input-data-tag-discription"
                        value={disc || ""}
                        onChange={(e) => setdisc(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="comp-disc-action-buttoms">
                      {/* <div className="comp-disc-action-buttoms">edit</div> */}

                      {edit ? (
                        <div
                          className="comp-disc-action-buttomss"
                          onClick={() => {
                            setedit(false);
                          }}
                        >
                          edit
                        </div>
                      ) : (
                        <div className="comp-disc-actions">
                          <div
                            className="comp-disc-action-buttomss"
                            onClick={handleEditDisc}
                          >
                            save
                          </div>
                          <div
                            className="comp-disc-action-cancel-button"
                            onClick={() => setedit(true)}
                          >
                            cancel
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* </div> */}
                </div>

                <div className="overview-company-structure">
                  <div className="compny-struc-text-box">
                    <div className="compny-struc-title-box">
                      <div className="compny-struc-title-icon">
                        <CompIcon />
                      </div>
                      <div className="compny-struc-title-text">
                        Company Structure
                      </div>
                    </div>
                    <div className="compny-struc-disc">
                      Manage entities operating under this company account.
                    </div>
                  </div>

                  <div
                    className="compny-struc-text-action-button"
                    onClick={() => navigate("/add-related-business")}
                  >
                    <div className="compny-struc-text-action-button-icon">
                      <PlusIcon fill="currentColor" />
                    </div>
                    <div className="compny-struc-text-action-button-text">
                      Related Business
                    </div>
                  </div>
                </div>
              </div>

              <div className="business-overview-footer">
                <div className="business-overview-relat-business-section">
                  <div
                    className={rowClass("Branches")}
                    onClick={() => setActive("Branches")}
                  >
                    Branches {item?.relatedCompanies?.BRANCH?.length}
                  </div>
                  <div
                    className={rowClass("Manufacturers")}
                    onClick={() => setActive("Manufacturers")}
                  >
                    Manufacturers {item?.relatedCompanies?.MANUFACTURER?.length}
                  </div>
                  <div
                    className={rowClass("Warehouses")}
                    onClick={() => setActive("Warehouses")}
                  >
                    Warehouses {item?.relatedCompanies?.WAREHOUSE?.length}
                  </div>
                </div>

                <div className="business-overview-branchs">
                  {active === "Branches" &&
                    (!Array.isArray(item?.relatedCompanies?.BRANCH) ? (
                      <div className="no-related-comp-icon">
                        <NoRelatedCom /> No Related Business Added Yet!
                      </div>
                    ) : (
                      item.relatedCompanies.BRANCH?.map((item) => (
                        <div
                          className="comp-branch-container"
                          key={item.id ?? index}
                        >
                          <div className="comp-branch">
                            <div className="comp-branch-disc">
                              <div className="comp-branch-logo">
                                <BranchLogo />
                              </div>
                              <div className="comp-branch-disc-text">
                                <div className="comp-branch-disc-title">
                                  {item.companyName}
                                </div>
                                <div className="comp-branch-disc-note">
                                  {item.companyCity} {item.companyCountry}
                                </div>
                              </div>
                            </div>

                            <div className="comp-branch-state-details">
                              <div
                                className={`comp-branch-state-${item.companyStatus?.toLowerCase()}`}
                              >
                                {item.companyStatus}
                              </div>
                              <div
                                className="comp-branch-state-icon"
                                onClick={() =>
                                  navigate("/view-company-attachements", {
                                    state: { compid: item.companyID },
                                  })
                                }
                              >
                                <ArrowFront />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ))}
                  {active === "Manufacturers" &&
                    (!Array.isArray(item?.relatedCompanies?.MANUFACTURER) ? (
                      <div className="no-related-comp-icon">
                        <NoRelatedCom />
                        No Related Business Added Yet!
                      </div>
                    ) : (
                      item.relatedCompanies?.MANUFACTURER?.map((item) => (
                        <div
                          className="comp-branch-container"
                          key={item.id ?? index}
                        >
                          <div className="comp-branch">
                            <div className="comp-branch-disc">
                              <div className="comp-branch-logo-manuf">
                                <BranchLogo />
                              </div>
                              <div className="comp-branch-disc-text">
                                <div className="comp-branch-disc-title">
                                  {item.companyName}
                                </div>
                                <div className="comp-branch-disc-note">
                                  {item.companyCity} {item.companyCountry}
                                </div>
                              </div>
                            </div>

                            <div className="comp-branch-state-details">
                              <div
                                className={`comp-branch-state-${item.companyStatus?.toLowerCase()}`}
                              >
                                {item.companyStatus}
                              </div>
                              <div
                                className="comp-branch-state-icon"
                                onClick={() =>
                                  navigate("/view-company-attachements", {
                                    state: { compid: item.companyID },
                                  })
                                }
                              >
                                <ArrowFront />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ))}

                  {active === "Warehouses" &&
                    (!Array.isArray(item?.relatedCompanies?.WAREHOUSE) ? (
                      <div className="no-related-comp-icon">
                        <NoRelatedCom />
                        No Related Business Added Yet!
                      </div>
                    ) : (
                      item.relatedCompanies?.WAREHOUSE?.map((item) => (
                        <div
                          className="comp-branch-container"
                          key={item.id ?? index}
                        >
                          <div className="comp-branch">
                            <div className="comp-branch-disc">
                              <div className="comp-branch-logo-ware">
                                <WarehousesIcon />
                              </div>
                              <div className="comp-branch-disc-text">
                                <div className="comp-branch-disc-title">
                                  {item.companyName}
                                </div>
                                <div className="comp-branch-disc-note">
                                  {item.companyCity} {item.companyCountry}{" "}
                                </div>
                              </div>
                            </div>

                            <div className="comp-branch-state-details">
                              <div
                                className={`comp-branch-state-${item.companyStatus?.toLowerCase()}`}
                              >
                                {item.companyStatus}
                              </div>
                              <div
                                className="comp-branch-state-icon"
                                onClick={() =>
                                  navigate("/view-company-attachements", {
                                    state: { compid: item.companyID },
                                  })
                                }
                              >
                                <ArrowFront />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ))}
                </div>
              </div>
            </div>
          ))}
      </div>
      {isLogoModalOpen && (
        <div className="company-logo-modal-overlay" onClick={closeLogoModal}>
          <div
            className="company-logo-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="company-logo-modal-title">Profile Photo</div>
            <div className="company-logo-modal-image-wrap">
              <img
                ref={modalPreviewImageRef}
                src={selectedCompanyLogo}
                alt="Company profile"
                className="company-logo-modal-image"
              />
            </div>
            <div className="company-logo-modal-actions">
              <div
                className="company-logo-modal-action"
                onClick={() => modalLogoInputRef.current?.click()}
              >
                <Uploadbutton />
                <span>Upload Photo</span>
              </div>
              {/* <div
                className="company-logo-modal-action"
                onClick={() => toast.info("Take photo is not available yet.")}
              >
                <div className="company-logo-modal-camera-icon"></div>
                <span>Take Photo</span>
              </div> */}
              <div
                className="company-logo-modal-action"
                onClick={openEditLogoModal}
              >
                <EditDetails />
                <span>
                  {isEditPreviewLoading ? "Loading..." : "Edit Photo"}
                </span>
              </div>
              {/* <div
                className="company-logo-modal-action"
                onClick={() => {
                  toast.info("Delete photo action is not connected yet.");
                  closeLogoModal();
                }}
              >
                <TrashIcon />
                <span>Delete Photo</span>
              </div> */}
            </div>
          </div>
        </div>
      )}
      {isEditLogoModalOpen && (
        <div className="company-logo-modal-overlay">
          <div className="company-logo-edit-modal-container">
            <div className="company-logo-edit-modal-title">Edit Photo</div>

            <div className="company-logo-edit-preview-area">
              <img
                ref={editPreviewImageRef}
                key={editPreviewSrc}
                src={editPreviewSrc}
                alt="Editable company profile"
                className="company-logo-edit-preview-image"
                style={{
                  transform: `scale(${editZoom}) rotate(${editRotate}deg)`,
                }}
              />
            </div>

            <div className="company-logo-edit-controls">
              <div className="company-logo-edit-zoom-row">
                <button
                  type="button"
                  className="company-logo-edit-zoom-btn"
                  onClick={() =>
                    setEditZoom((prev) =>
                      Math.max(
                        minEditZoom,
                        Number((prev - editZoomStep).toFixed(1)),
                      ),
                    )
                  }
                >
                  -
                </button>
                <input
                  type="range"
                  min={minEditZoom}
                  max={maxEditZoom}
                  step={editZoomStep}
                  value={editZoom}
                  onChange={(e) => setEditZoom(Number(e.target.value))}
                />
                <button
                  type="button"
                  className="company-logo-edit-zoom-btn"
                  onClick={() =>
                    setEditZoom((prev) =>
                      Math.min(
                        maxEditZoom,
                        Number((prev + editZoomStep).toFixed(1)),
                      ),
                    )
                  }
                >
                  +
                </button>
              </div>
              <div className="company-logo-edit-zoom-label">Zoom</div>

              <div className="company-logo-edit-rotate-row">
                <button
                  type="button"
                  className="company-logo-edit-rotate-btn"
                  onClick={() => setEditRotate((prev) => prev - 90)}
                >
                  &#8634;
                </button>
                <button
                  type="button"
                  className="company-logo-edit-rotate-btn"
                  onClick={() => setEditRotate((prev) => prev + 90)}
                >
                  &#8635;
                </button>
              </div>

              <div className="company-logo-edit-actions">
                <button
                  type="button"
                  className="company-logo-edit-cancel-btn"
                  onClick={closeEditLogoModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="company-logo-edit-save-btn"
                  onClick={saveEditLogoModal}
                  disabled={isSavingEditedLogo}
                >
                  {isSavingEditedLogo ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <input
        type="file"
        ref={modalLogoInputRef}
        style={{ display: "none" }}
        onChange={onLogoInputChange}
      />
    </div>
  );
}

export default BussinessOverview;
